"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct.bind(); } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var VariantSelects = /*#__PURE__*/function (_HTMLElement) {
  _inherits(VariantSelects, _HTMLElement);
  var _super = _createSuper(VariantSelects);
  function VariantSelects() {
    var _this;
    _classCallCheck(this, VariantSelects);
    _this = _super.call(this);
    _this.addEventListener('change', _this.onVariantChange);
    return _this;
  }
  _createClass(VariantSelects, [{
    key: "onVariantChange",
    value: function onVariantChange(e) {
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.updatePickupAvailability();
      this.updateInventoryStatus();
      this.removeErrorMessage();
      this.updateVariantStatuses();
      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        this.updateMedia();
        this.updateURL();
        this.updateVariantInput();
        this.renderProductInfo();
        this.updateShareUrl();
        var currentVariantPrice = this.currentVariant.price;
        currentVariantPrice = parseInt(currentVariantPrice);
        if(currentVariantPrice > 0)
        {

        }
        else
        {
          this.customUpdateAddToCartButton();  
        }
      }
    }
  }, {
    key: "updateOptions",
    value: function updateOptions() {
      this.options = Array.from(this.querySelectorAll('select'), function (select) {
        return select.value;
      });
    }
  }, {
    key: "customUpdateAddToCartButton",
    value: function customUpdateAddToCartButton() {
      var _thisCustom = this;
      var productForm = document.getElementById("product-form-".concat(this.dataset.section));
      if (!productForm) return;
      var text = productForm.querySelector('.product-form__buttons').getAttribute("data-button-disabled-price-issue");
      var addButton = productForm.querySelector('[name="add"]');
      var addButtonText = productForm.querySelector('[name="add"] > span');
      if(text) 
      {
        setTimeout(function () {
          addButton.setAttribute('disabled', 'disabled');
          addButtonText.textContent = text;
        }, 800);
      }
    }
  },{
    key: "updateMasterId",
    value: function updateMasterId() {
      var _this2 = this;
      this.currentVariant = this.getVariantData().find(function (variant) {
        return !variant.options.map(function (option, index) {
          return _this2.options[index] === option;
        }).includes(false);
      });
    }
  }, {
    key: "updateMedia",
    value: function updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;
      var mediaGridySlider = document.getElementById("slider-".concat(this.dataset.section));
      var thumbnailsGridySlider = document.getElementById("thumbnail-slider-".concat(this.dataset.section));
      if (mediaGridySlider) {
        mediaGridySlider.scrollToSlideByID("item-".concat(this.currentVariant.featured_media.id));
      }
      if (thumbnailsGridySlider) {
        thumbnailsGridySlider.scrollToSlideByID("thumbnail-item-".concat(this.currentVariant.featured_media.id));
      }
    }
  }, {
    key: "updateURL",
    value: function updateURL() {
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', "".concat(this.dataset.url, "?variant=").concat(this.currentVariant.id));
    }
  }, {
    key: "updateShareUrl",
    value: function updateShareUrl() {
      var shareButton = document.getElementById("Share-".concat(this.dataset.section));
      if (!shareButton || !shareButton.updateUrl) return;
      shareButton.updateUrl("".concat(window.shopUrl).concat(this.dataset.url, "?variant=").concat(this.currentVariant.id));
    }
  }, {
    key: "updateVariantInput",
    value: function updateVariantInput() {
      var _this3 = this;
      var productForms = document.querySelectorAll("#product-form-".concat(this.dataset.section, ", #product-form-installment-").concat(this.dataset.section, ", #product-form-").concat(this.dataset.section, "-product-buy-bar"));
      productForms.forEach(function (productForm) {
        var input = productForm.querySelector('input[name="id"]');
        input.value = _this3.currentVariant.id;
        input.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      });
    }
  }, {
    key: "updateVariantStatuses",
    value: function updateVariantStatuses() {
      var _this4 = this;
      var selectedOptionOneVariants = this.variantData.filter(function (variant) {
        return _this4.querySelector(':checked').value === variant.option1;
      });
      var inputWrappers = _toConsumableArray(this.querySelectorAll('.product-form__input'));
      inputWrappers.forEach(function (option, index) {
        if (index === 0) return;
        var optionInputs = _toConsumableArray(option.querySelectorAll('input[type="radio"], option'));
        var previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
        var availableOptionInputsValue = selectedOptionOneVariants.filter(function (variant) {
          return variant.available && variant["option".concat(index)] === previousOptionSelected;
        }).map(function (variantOption) {
          return variantOption["option".concat(index + 1)];
        });
        _this4.setInputAvailability(optionInputs, availableOptionInputsValue);
      });
    }
  }, {
    key: "setInputAvailability",
    value: function setInputAvailability(listOfOptions, listOfAvailableOptions) {
      listOfOptions.forEach(function (input) {
        if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
          input.innerText = input.getAttribute('value');
        } else {
          input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
        }
      });
    }
  }, {
    key: "updatePickupAvailability",
    value: function updatePickupAvailability() {
      var pickUpAvailability = document.querySelector('pickup-availability');
      if (!pickUpAvailability) return;
      if (this.currentVariant && this.currentVariant.available) {
        pickUpAvailability.fetchAvailability(this.currentVariant.id);
      } else {
        pickUpAvailability.removeAttribute('available');
        pickUpAvailability.innerHTML = '';
      }
    }
  }, {
    key: "updateInventoryStatus",
    value: function updateInventoryStatus() {
      var _this$currentVariant;
      this.productInventoryNode = document.querySelector('[data-product-inventory]');
      if (!this.productInventoryNode || !window.inventories || !window.inventories[this.dataset.productId]) return;
      this.inventoryThreshold = parseInt(this.productInventoryNode.dataset.threshold);
      this.showQuantityInStock = this.productInventoryNode.dataset.showQuantityInStock;
      var variantInventoryObject = window.inventories[this.dataset.productId][(_this$currentVariant = this.currentVariant) === null || _this$currentVariant === void 0 ? void 0 : _this$currentVariant.id];
      if (!this.currentVariant || !this.currentVariant.inventory_management) {
        this.toggleInventoryQuantity(false);
        this.toggleIncomingInventory(false);
        return;
      }
      if (this.currentVariant.inventory_management === 'shopify') {
        if (variantInventoryObject.quantity <= 0 && variantInventoryObject.incoming === 'true' && variantInventoryObject.quantity < this.inventoryThreshold) {
          this.toggleInventoryQuantity(false);
          this.toggleIncomingInventory(true, variantInventoryObject.next_incoming_date);
        } else {
          this.toggleInventoryQuantity(true, variantInventoryObject.quantity);
          this.toggleIncomingInventory(false);
        }
      }
    }
  }, {
    key: "toggleInventoryQuantity",
    value: function toggleInventoryQuantity(show, quantity) {
      if (show === false) {
        this.productInventoryNode.classList.add('hide');
        return;
      }
      this.productInventoryNode.classList.remove('inventory-status--in-stock', 'inventory-status--low', 'inventory-status--sold-out', 'inventory-status--sold-out-continue-selling');
      if (this.currentVariant && this.currentVariant.available && parseInt(quantity) <= parseInt(this.inventoryThreshold) && parseInt(quantity) > 0) {
        this.productInventoryNode.classList.add('inventory-status--low');
        if (!this.showQuantityInStock === 'true') {
          this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.few_left_with_quantity.replace('[quantity]', quantity);
        } else {
          this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.few_left;
        }
      } else if (this.currentVariant && this.currentVariant.available && parseInt(quantity) > parseInt(this.inventoryThreshold)) {
        this.productInventoryNode.classList.add('inventory-status--in-stock');
        if (!this.showQuantityInStock === 'true') {
          this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.in_stock_with_quantity.replace('[quantity]', quantity);
        } else {
          this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.in_stock;
        }
      } else if (this.currentVariant && this.currentVariant.available && parseInt(quantity) < 1) {
        this.productInventoryNode.classList.add('inventory-status--sold-out-continue-selling');
        this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.out_of_stock_continue_selling;
      } else {
        this.productInventoryNode.classList.add('inventory-status--sold-out');
        this.productInventoryNode.firstElementChild.textContent = window.variantStrings.inventory.out_of_stock;
      }
      this.productInventoryNode.classList.remove('hide');
    }
  }, {
    key: "toggleIncomingInventory",
    value: function toggleIncomingInventory(show, date) {
      var incomingInventoryNode = document.querySelector('[data-incoming-inventory]');
      if (!incomingInventoryNode) return;
      if (show == false && incomingInventoryNode) {
        incomingInventoryNode.classList.add('hide');
        return;
      }
      var string = !date ? window.variantStrings.inventory.waiting_for_stock : window.variantStrings.inventory.will_be_in_stock_after.replace('[date]', date);
      incomingInventoryNode.classList.remove('hide');
      incomingInventoryNode.firstElementChild.textContent = string;
    }
  }, {
    key: "removeErrorMessage",
    value: function removeErrorMessage() {
      var section = this.closest('section');
      if (!section) return;
      var productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
    }
  }, {
    key: "renderProductInfo",
    value: function renderProductInfo() {
      var _this5 = this;
      fetch("".concat(this.dataset.url, "?variant=").concat(this.currentVariant.id, "&section_id=").concat(this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section)).then(function (response) {
        return response.text();
      }).then(function (responseText) {
        var html = new DOMParser().parseFromString(responseText, 'text/html');
        var destination = document.getElementById("price-".concat(_this5.dataset.section));
        var destinationBuyBarInfo = document.getElementById("buy-bar-info-".concat(_this5.dataset.section));
        var source = html.getElementById("price-".concat(_this5.dataset.originalSection ? _this5.dataset.originalSection : _this5.dataset.section));
        var buyBarInfoSource = html.getElementById("buy-bar-info-".concat(_this5.dataset.originalSection ? _this5.dataset.originalSection : _this5.dataset.section));
        if (source && destination) destination.innerHTML = source.innerHTML;
        if (source && destinationBuyBarInfo) destinationBuyBarInfo.innerHTML = buyBarInfoSource.innerHTML;
        var price = document.getElementById("price-".concat(_this5.dataset.section));
        if (price) price.classList.remove('hidden');
        _this5.toggleAddButton(!_this5.currentVariant.available, window.variantStrings.soldOut);
      });
    }
  }, {
    key: "toggleAddButton",
    value: function toggleAddButton() {
      var disable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      var text = arguments.length > 1 ? arguments[1] : undefined;
      var modifyClass = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var productForm = document.getElementById("product-form-".concat(this.dataset.section));
      if (!productForm) return;
      var addButton = productForm.querySelector('[name="add"]');
      var addButtonText = productForm.querySelector('[name="add"] > span');
      if (!addButton) return;
      if (disable) {
        addButton.setAttribute('disabled', 'disabled');
        if (text) addButtonText.textContent = text;
      } else {
        addButton.removeAttribute('disabled');
        if (this.dataset.isPreorder == 'true') {
          addButtonText.textContent = window.variantStrings.preOrder;
        } else {
          addButtonText.textContent = window.variantStrings.addToCart;
        }
      }
      var productForm_BuyBar = document.getElementById("product-form-".concat(this.dataset.section, "-product-buy-bar"));
      if (productForm_BuyBar) {
        var addButton_BuyBar = productForm_BuyBar.querySelector('[name="add"]');
        var addButtonText_BuyBar = productForm_BuyBar.querySelector('[name="add"] > span');
        if (disable) {
          addButton_BuyBar.setAttribute("disabled", "disabled");
          if (text) addButtonText_BuyBar.textContent = text;
        } else {
          addButton_BuyBar.removeAttribute("disabled");
          if (this.dataset.isPreorder == "true") {
            addButtonText_BuyBar.textContent = window.variantStrings.preOrder;
          } else {
            addButtonText_BuyBar.textContent = window.variantStrings.addToCart;
          }
        }
      }
      if (!modifyClass) return;
    }
  }, {
    key: "setUnavailable",
    value: function setUnavailable() {
      var button = document.getElementById("product-form-".concat(this.dataset.section));
      var addButton = button.querySelector('[name="add"]');
      var addButtonText = button.querySelector('[name="add"] > span');
      var price = document.getElementById("price-".concat(this.dataset.section));
      if (!addButton) return;
      addButtonText.textContent = window.variantStrings.unavailable;
      if (price) price.classList.add('hidden');
      var button_BuyBar = document.getElementById("product-form-".concat(this.dataset.section, "-product-buy-bar"));
      if(button_BuyBar)
      {
       var addButton_BuyBar = button_BuyBar.querySelector('[name="add"]');
        var addButtonText_BuyBar = button_BuyBar.querySelector('[name="add"] > span');
        var price_BuyBar = document.getElementById("price-".concat(this.dataset.section, "-product-buy-bar"));
        if (!addButton_BuyBar) return;
        addButtonText_BuyBar.textContent = window.variantStrings.unavailable;
        if (price_BuyBar) price_BuyBar.classList.add("hidden"); 
      }
      if (document.querySelector(".product-block__buy_buttons product-form") && document.querySelector(".product-block__buy_buttons .back-in-stock-klaviyo-form-wrapper")) {
        document.querySelector(".product-block__buy_buttons product-form").style.display = "block";
        document.querySelector(".product-block__buy_buttons .back-in-stock-klaviyo-form-wrapper").style.display = "none";
      }
    }
  }, {
    key: "getVariantData",
    value: function getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.parentElement.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  }]);
  return VariantSelects;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('variant-selects', VariantSelects);
var VariantRadios = /*#__PURE__*/function (_VariantSelects) {
  _inherits(VariantRadios, _VariantSelects);
  var _super2 = _createSuper(VariantRadios);
  function VariantRadios() {
    _classCallCheck(this, VariantRadios);
    return _super2.call(this);
  }
  _createClass(VariantRadios, [{
    key: "setInputAvailability",
    value: function setInputAvailability(listOfOptions, listOfAvailableOptions) {
      listOfOptions.forEach(function (input) {
        if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
          input.classList.remove('disabled');
        } else {
          input.classList.add('disabled');
        }
      });
      var getCustomDropdown = document.querySelectorAll(".change-size-option-dropdown .customDropdown ul li");
      if (getCustomDropdown) {
        document.querySelectorAll(".change-size-option-dropdown .customDropdown ul li").forEach(function (input) {
          var getListValue = input.querySelector("a span.value span").innerText;
          if (listOfAvailableOptions.includes(getListValue)) {
            input.classList.remove('disabled');
          } else {
            input.classList.add('disabled');
          }
        });
      }
      this.customOptionChange();
    }
  }, {
    key: "customOptionChange",
    value: function customOptionChange() {
      var getOptions = document.querySelectorAll(".product-block__variant_picker .product-form__input");
      if (getOptions) {
        if (getOptions.length == 1) {
          document.querySelectorAll(".product-block__variant_picker .product-form__input").forEach(function (option, optionKey) {
            var getAllRadios = option.querySelectorAll("input[type='radio']");
            if (getAllRadios) {
              getAllRadios.forEach(function (input, key) {
                var getInputValue = input.value;
                var isMatched = false;
                document.querySelectorAll(".customProductSelect option").forEach(function (selectOption, selectOptionKey) {
                  var getSelectOptionMatchValue = selectOption.getAttribute("data-match");
                  var variantAvailable = selectOption.getAttribute('data-available');
                  var variantInventory = selectOption.getAttribute("data-inventory");
                  var variantInventoryManagement = selectOption.getAttribute("data-inventory-management");
                  variantInventory = parseInt(variantInventory) + 0;
                  if (typeof getSelectOptionMatchValue != "undefined" && getSelectOptionMatchValue != null && getSelectOptionMatchValue != "") {
                    if (getSelectOptionMatchValue == getInputValue) {
                      isMatched = true;
                      if (variantAvailable == "true") {
                        input.nextElementSibling.classList.remove("low-stock");
                        input.nextElementSibling.classList.remove("disabled");
                        if (typeof variantInventoryManagement != "undefined" && variantInventoryManagement != null && variantInventoryManagement != "") {
                          if (variantInventory < 4) {
                            input.nextElementSibling.classList.remove("disabled");
                            input.nextElementSibling.classList.add("low-stock");
                          }
                        }
                      } else {
                        input.nextElementSibling.classList.remove("low-stock");
                        input.nextElementSibling.classList.add("disabled");
                      }
                    }
                  }
                });
                if (!isMatched) {
                  input.nextElementSibling.classList.remove("low-stock");
                  input.nextElementSibling.classList.add("disabled");
                }
              });
            }
            var getAllCustomUlLI = option.querySelectorAll(".customDropdown ul li");
            if (getAllCustomUlLI) {
              getAllCustomUlLI.forEach(function (input, key) {
                var getInputValue = input.querySelector("a span.value span").innerText;
                var isMatched = false;
                document.querySelectorAll(".customProductSelect option").forEach(function (selectOption, selectOptionKey) {
                  var getSelectOptionMatchValue = selectOption.getAttribute("data-match");
                  var variantAvailable = selectOption.getAttribute('data-available');
                  var variantInventory = selectOption.getAttribute("data-inventory");
                  var variantInventoryManagement = selectOption.getAttribute("data-inventory-management");
                  variantInventory = parseInt(variantInventory) + 0;
                  if (typeof getSelectOptionMatchValue != "undefined" && getSelectOptionMatchValue != null && getSelectOptionMatchValue != "") {
                    if (getSelectOptionMatchValue == getInputValue) {
                      isMatched = true;
                      if (variantAvailable == "true") {
                        input.classList.remove("low-stock");
                        input.classList.remove("disabled");
                        if (typeof variantInventoryManagement != "undefined" && variantInventoryManagement != null && variantInventoryManagement != "") {
                          if (variantInventory > 0 && variantInventory < 4) {
                            input.classList.remove("disabled");
                            input.classList.add("low-stock");
                          }
                        }
                      } else {
                        input.classList.remove("low-stock");
                        input.classList.add("disabled");
                      }
                    }
                  }
                });
                if (!isMatched) {
                  input.classList.remove("low-stock");
                  input.classList.add("disabled");
                }
              });
            }
          });
        } else if (getOptions.length == 2) {
          var option1Value = "";
          var option2Value = "";
          document.querySelectorAll(".product-block__variant_picker .product-form__input").forEach(function (option, optionKey) {
            if (optionKey == 0) {
              var getAllRadios = option.querySelectorAll("input[type='radio']");
              if (getAllRadios) {
                getAllRadios.forEach(function (input, key) {
                  if (input.checked == true) {
                    option1Value = input.value;
                  }
                });
              }
            } else if (optionKey == 1) {
              var getAllRadios = option.querySelectorAll("input[type='radio']");
              if (getAllRadios) {
                getAllRadios.forEach(function (input, key) {
                  if (input.checked == true) {
                    option2Value = input.value;
                  }
                });
              }
            }
          });
          if (typeof option1Value != "undefined" && option1Value != null && option1Value != "") {
            document.querySelectorAll(".product-block__variant_picker .product-form__input").forEach(function (option, optionKey) {
              if (optionKey == 1) {
                var getAllRadios = option.querySelectorAll("input[type='radio']");
                if (getAllRadios) {
                  getAllRadios.forEach(function (input, key) {
                    var getInputValue = input.value;
                    var isMatched = false;
                    var addBothValue = option1Value + " / " + getInputValue;
                    document.querySelectorAll(".customProductSelect option").forEach(function (selectOption, selectOptionKey) {
                      var getSelectOptionMatchValue = selectOption.getAttribute("data-match");
                      var variantAvailable = selectOption.getAttribute('data-available');
                      var variantInventory = selectOption.getAttribute("data-inventory");
                      var variantInventoryManagement = selectOption.getAttribute("data-inventory-management");
                      variantInventory = parseInt(variantInventory) + 0;
                      if (typeof getSelectOptionMatchValue != "undefined" && getSelectOptionMatchValue != null && getSelectOptionMatchValue != "") {
                        if (getSelectOptionMatchValue == addBothValue) {
                          isMatched = true;
                          if (variantAvailable == "true") {
                            input.nextElementSibling.classList.remove("low-stock");
                            input.nextElementSibling.classList.remove("disabled");
                            if (typeof variantInventoryManagement != "undefined" && variantInventoryManagement != null && variantInventoryManagement != "") {
                              if (variantInventory > 0 && variantInventory < 4) {
                                input.nextElementSibling.classList.remove("disabled");
                                input.nextElementSibling.classList.add("low-stock");
                              }
                            }
                          } else {
                            input.nextElementSibling.classList.remove("low-stock");
                            input.nextElementSibling.classList.add("disabled");
                          }
                        }
                      }
                    });
                    if (!isMatched) {
                      input.nextElementSibling.classList.remove("low-stock");
                      input.nextElementSibling.classList.add("disabled");
                    }
                  });
                }
                var getAllCustomUlLI = option.querySelectorAll(".customDropdown ul li");
                if (getAllCustomUlLI) {
                  getAllCustomUlLI.forEach(function (input, key) {
                    var getInputValue = input.querySelector("a span.value span").innerText;
                    var isMatched = false;
                    var addBothValue = option1Value + " / " + getInputValue;
                    document.querySelectorAll(".customProductSelect option").forEach(function (selectOption, selectOptionKey) {
                      var getSelectOptionMatchValue = selectOption.getAttribute("data-match");
                      var variantAvailable = selectOption.getAttribute('data-available');
                      var variantInventory = selectOption.getAttribute("data-inventory");
                      var variantInventoryManagement = selectOption.getAttribute("data-inventory-management");
                      variantInventory = parseInt(variantInventory) + 0;
                      if (typeof getSelectOptionMatchValue != "undefined" && getSelectOptionMatchValue != null && getSelectOptionMatchValue != "") {
                        if (getSelectOptionMatchValue == addBothValue) {
                          isMatched = true;
                          if (variantAvailable == "true") {
                            input.classList.remove("low-stock");
                            input.classList.remove("disabled");
                            if (typeof variantInventoryManagement != "undefined" && variantInventoryManagement != null && variantInventoryManagement != "") {
                              if (variantInventory < 4) {
                                input.classList.remove("disabled");
                                input.classList.add("low-stock");
                              }
                            }
                          } else {
                            input.classList.remove("low-stock");
                            input.classList.add("disabled");
                          }
                        }
                      }
                    });
                    if (!isMatched) {
                      input.classList.remove("low-stock");
                      input.classList.add("disabled");
                    }
                  });
                }
              }
            });
          }
          if (typeof option2Value != "undefined" && option2Value != null && option2Value != "") {
            document.querySelectorAll(".product-block__variant_picker .product-form__input").forEach(function (option, optionKey) {
              if (optionKey == 0) {
                var getAllRadios = option.querySelectorAll("input[type='radio']");
                if (getAllRadios) {
                  getAllRadios.forEach(function (input, key) {
                    var getInputValue = input.value;
                    var isMatched = false;
                    var addBothValue = getInputValue + " / " + option2Value;
                    document.querySelectorAll(".customProductSelect option").forEach(function (selectOption, selectOptionKey) {
                      var getSelectOptionMatchValue = selectOption.getAttribute("data-match");
                      var variantAvailable = selectOption.getAttribute('data-available');
                      var variantInventory = selectOption.getAttribute("data-inventory");
                      var variantInventoryManagement = selectOption.getAttribute("data-inventory-management");
                      variantInventory = parseInt(variantInventory) + 0;
                      if (typeof getSelectOptionMatchValue != "undefined" && getSelectOptionMatchValue != null && getSelectOptionMatchValue != "") {
                        if (getSelectOptionMatchValue == addBothValue) {
                          isMatched = true;
                          if (variantAvailable == "true") {
                            input.nextElementSibling.classList.remove("low-stock");
                            input.nextElementSibling.classList.remove("disabled");
                            if (typeof variantInventoryManagement != "undefined" && variantInventoryManagement != null && variantInventoryManagement != "") {
                              if (variantInventory < 4) {
                                input.nextElementSibling.classList.remove("disabled");
                                input.nextElementSibling.classList.add("low-stock");
                              }
                            }
                          } else {
                            input.nextElementSibling.classList.remove("low-stock");
                            input.nextElementSibling.classList.add("disabled");
                          }
                        }
                      }
                    });
                    if (!isMatched) {
                      input.nextElementSibling.classList.remove("low-stock");
                      input.nextElementSibling.classList.add("disabled");
                    }
                  });
                }
                var getAllCustomUlLI = option.querySelectorAll(".customDropdown ul li");
                if (getAllCustomUlLI) {
                  getAllCustomUlLI.forEach(function (input, key) {
                    var getInputValue = input.querySelector("a span.value span").innerText;
                    var isMatched = false;
                    var addBothValue = getInputValue + " / " + option2Value;
                    document.querySelectorAll(".customProductSelect option").forEach(function (selectOption, selectOptionKey) {
                      var getSelectOptionMatchValue = selectOption.getAttribute("data-match");
                      var variantAvailable = selectOption.getAttribute('data-available');
                      var variantInventory = selectOption.getAttribute("data-inventory");
                      var variantInventoryManagement = selectOption.getAttribute("data-inventory-management");
                      variantInventory = parseInt(variantInventory) + 0;
                      if (typeof getSelectOptionMatchValue != "undefined" && getSelectOptionMatchValue != null && getSelectOptionMatchValue != "") {
                        if (getSelectOptionMatchValue == addBothValue) {
                          isMatched = true;
                          if (variantAvailable == "true") {
                            input.classList.remove("low-stock");
                            input.classList.remove("disabled");
                            if (typeof variantInventoryManagement != "undefined" && variantInventoryManagement != null && variantInventoryManagement != "") {
                              if (variantInventory < 4) {
                                input.classList.remove("disabled");
                                input.classList.add("low-stock");
                              }
                            }
                          } else {
                            input.classList.remove("low-stock");
                            input.classList.add("disabled");
                          }
                        }
                      }
                    });
                    if (!isMatched) {
                      input.classList.remove("low-stock");
                      input.classList.add("disabled");
                    }
                  });
                }
              }
            });
          }
        } else if (getOptions.length == 3) {
          var option1Value = "";
          var option2Value = "";
          var option3Value = "";
          document.querySelectorAll(".product-block__variant_picker .product-form__input").forEach(function (option, optionKey) {
            if (optionKey == 0) {
              var getAllRadios = option.querySelectorAll("input[type='radio']");
              if (getAllRadios) {
                getAllRadios.forEach(function (input, key) {
                  if (input.checked == true) {
                    option1Value = input.value;
                  }
                });
              }
            } else if (optionKey == 1) {
              var getAllRadios = option.querySelectorAll("input[type='radio']");
              if (getAllRadios) {
                getAllRadios.forEach(function (input, key) {
                  if (input.checked == true) {
                    option2Value = input.value;
                  }
                });
              }
            } else if (optionKey == 2) {
              var getAllRadios = option.querySelectorAll("input[type='radio']");
              if (getAllRadios) {
                getAllRadios.forEach(function (input, key) {
                  if (input.checked == true) {
                    option3Value = input.value;
                  }
                });
              }
            }
          });
          if (typeof option1Value != "undefined" && option1Value != null && option1Value != "" && typeof option2Value != "undefined" && option2Value != null && option2Value != "") {
            document.querySelectorAll(".product-block__variant_picker .product-form__input").forEach(function (option, optionKey) {
              if (optionKey == 2) {
                var getAllRadios = option.querySelectorAll("input[type='radio']");
                if (getAllRadios) {
                  getAllRadios.forEach(function (input, key) {
                    var getInputValue = input.value;
                    var isMatched = false;
                    var addBothValue = option1Value + " / " + option2Value + " / " + getInputValue;
                    document.querySelectorAll(".customProductSelect option").forEach(function (selectOption, selectOptionKey) {
                      var getSelectOptionMatchValue = selectOption.getAttribute("data-match");
                      var variantAvailable = selectOption.getAttribute('data-available');
                      var variantInventory = selectOption.getAttribute("data-inventory");
                      var variantInventoryManagement = selectOption.getAttribute("data-inventory-management");
                      variantInventory = parseInt(variantInventory) + 0;
                      if (typeof getSelectOptionMatchValue != "undefined" && getSelectOptionMatchValue != null && getSelectOptionMatchValue != "") {
                        if (getSelectOptionMatchValue == addBothValue) {
                          isMatched = true;
                          if (variantAvailable == "true") {
                            input.nextElementSibling.classList.remove("low-stock");
                            input.nextElementSibling.classList.remove("disabled");
                            if (typeof variantInventoryManagement != "undefined" && variantInventoryManagement != null && variantInventoryManagement != "") {
                              if (variantInventory < 4) {
                                input.nextElementSibling.classList.remove("disabled");
                                input.nextElementSibling.classList.add("low-stock");
                              }
                            }
                          } else {
                            input.nextElementSibling.classList.remove("low-stock");
                            input.nextElementSibling.classList.add("disabled");
                          }
                        }
                      }
                    });
                    if (!isMatched) {
                      input.nextElementSibling.classList.remove("low-stock");
                      input.nextElementSibling.classList.add("disabled");
                    }
                  });
                }
                var getAllCustomUlLI = option.querySelectorAll(".customDropdown ul li");
                if (getAllCustomUlLI) {
                  getAllCustomUlLI.forEach(function (input, key) {
                    var getInputValue = input.querySelector("a span.value span").innerText;
                    var isMatched = false;
                    var addBothValue = option1Value + " / " + option2Value + " / " + getInputValue;
                    document.querySelectorAll(".customProductSelect option").forEach(function (selectOption, selectOptionKey) {
                      var getSelectOptionMatchValue = selectOption.getAttribute("data-match");
                      var variantAvailable = selectOption.getAttribute('data-available');
                      var variantInventory = selectOption.getAttribute("data-inventory");
                      var variantInventoryManagement = selectOption.getAttribute("data-inventory-management");
                      variantInventory = parseInt(variantInventory) + 0;
                      if (typeof getSelectOptionMatchValue != "undefined" && getSelectOptionMatchValue != null && getSelectOptionMatchValue != "") {
                        if (getSelectOptionMatchValue == addBothValue) {
                          isMatched = true;
                          if (variantAvailable == "true") {
                            input.classList.remove("low-stock");
                            input.classList.remove("disabled");
                            if (typeof variantInventoryManagement != "undefined" && variantInventoryManagement != null && variantInventoryManagement != "") {
                              if (variantInventory < 4) {
                                input.classList.remove("disabled");
                                input.classList.add("low-stock");
                              }
                            }
                          } else {
                            input.classList.remove("low-stock");
                            input.classList.add("disabled");
                          }
                        }
                      }
                    });
                    if (!isMatched) {
                      input.classList.remove("low-stock");
                      input.classList.add("disabled");
                    }
                  });
                }
              }
            });
          }
          if (typeof option2Value != "undefined" && option2Value != null && option2Value != "" && typeof option3Value != "undefined" && option3Value != null && option3Value != "") {
            document.querySelectorAll(".product-block__variant_picker .product-form__input").forEach(function (option, optionKey) {
              if (optionKey == 0) {
                var getAllRadios = option.querySelectorAll("input[type='radio']");
                if (getAllRadios) {
                  getAllRadios.forEach(function (input, key) {
                    var getInputValue = input.value;
                    var isMatched = false;
                    var addBothValue = getInputValue + " / " + option2Value + " / " + option3Value;
                    document.querySelectorAll(".customProductSelect option").forEach(function (selectOption, selectOptionKey) {
                      var getSelectOptionMatchValue = selectOption.getAttribute("data-match");
                      var variantAvailable = selectOption.getAttribute('data-available');
                      var variantInventory = selectOption.getAttribute("data-inventory");
                      var variantInventoryManagement = selectOption.getAttribute("data-inventory-management");
                      variantInventory = parseInt(variantInventory) + 0;
                      if (typeof getSelectOptionMatchValue != "undefined" && getSelectOptionMatchValue != null && getSelectOptionMatchValue != "") {
                        if (getSelectOptionMatchValue == addBothValue) {
                          isMatched = true;
                          if (variantAvailable == "true") {
                            input.nextElementSibling.classList.remove("low-stock");
                            input.nextElementSibling.classList.remove("disabled");
                            if (typeof variantInventoryManagement != "undefined" && variantInventoryManagement != null && variantInventoryManagement != "") {
                              if (variantInventory < 4) {
                                input.nextElementSibling.classList.remove("disabled");
                                input.nextElementSibling.classList.add("low-stock");
                              }
                            }
                          } else {
                            input.nextElementSibling.classList.remove("low-stock");
                            input.nextElementSibling.classList.add("disabled");
                          }
                        }
                      }
                    });
                    if (!isMatched) {
                      input.nextElementSibling.classList.remove("low-stock");
                      input.nextElementSibling.classList.add("disabled");
                    }
                  });
                }
                var getAllCustomUlLI = option.querySelectorAll(".customDropdown ul li");
                if (getAllCustomUlLI) {
                  getAllCustomUlLI.forEach(function (input, key) {
                    var getInputValue = input.querySelector("a span.value span").innerText;
                    var isMatched = false;
                    var addBothValue = getInputValue + " / " + option2Value + " / " + option3Value;
                    document.querySelectorAll(".customProductSelect option").forEach(function (selectOption, selectOptionKey) {
                      var getSelectOptionMatchValue = selectOption.getAttribute("data-match");
                      var variantAvailable = selectOption.getAttribute('data-available');
                      var variantInventory = selectOption.getAttribute("data-inventory");
                      var variantInventoryManagement = selectOption.getAttribute("data-inventory-management");
                      variantInventory = parseInt(variantInventory) + 0;
                      if (typeof getSelectOptionMatchValue != "undefined" && getSelectOptionMatchValue != null && getSelectOptionMatchValue != "") {
                        if (getSelectOptionMatchValue == addBothValue) {
                          isMatched = true;
                          if (variantAvailable == "true") {
                            input.classList.remove("low-stock");
                            input.classList.remove("disabled");
                            if (typeof variantInventoryManagement != "undefined" && variantInventoryManagement != null && variantInventoryManagement != "") {
                              if (variantInventory < 4) {
                                input.classList.remove("disabled");
                                input.classList.add("low-stock");
                              }
                            }
                          } else {
                            input.classList.remove("low-stock");
                            input.classList.add("disabled");
                          }
                        }
                      }
                    });
                    if (!isMatched) {
                      input.classList.remove("low-stock");
                      input.classList.add("disabled");
                    }
                  });
                }
              }
            });
          }
          if (typeof option1Value != "undefined" && option1Value != null && option1Value != "" && typeof option3Value != "undefined" && option3Value != null && option3Value != "") {
            document.querySelectorAll(".product-block__variant_picker .product-form__input").forEach(function (option, optionKey) {
              if (optionKey == 1) {
                var getAllRadios = option.querySelectorAll("input[type='radio']");
                if (getAllRadios) {
                  getAllRadios.forEach(function (input, key) {
                    var getInputValue = input.value;
                    var isMatched = false;
                    var addBothValue = option1Value + " / " + getInputValue + " / " + option3Value;
                    document.querySelectorAll(".customProductSelect option").forEach(function (selectOption, selectOptionKey) {
                      var getSelectOptionMatchValue = selectOption.getAttribute("data-match");
                      var variantAvailable = selectOption.getAttribute('data-available');
                      var variantInventory = selectOption.getAttribute("data-inventory");
                      var variantInventoryManagement = selectOption.getAttribute("data-inventory-management");
                      variantInventory = parseInt(variantInventory) + 0;
                      if (typeof getSelectOptionMatchValue != "undefined" && getSelectOptionMatchValue != null && getSelectOptionMatchValue != "") {
                        if (getSelectOptionMatchValue == addBothValue) {
                          isMatched = true;
                          if (variantAvailable == "true") {
                            input.nextElementSibling.classList.remove("low-stock");
                            input.nextElementSibling.classList.remove("disabled");
                            if (typeof variantInventoryManagement != "undefined" && variantInventoryManagement != null && variantInventoryManagement != "") {
                              if (variantInventory < 4) {
                                input.nextElementSibling.classList.remove("disabled");
                                input.nextElementSibling.classList.add("low-stock");
                              }
                            }
                          } else {
                            input.nextElementSibling.classList.remove("low-stock");
                            input.nextElementSibling.classList.add("disabled");
                          }
                        }
                      }
                    });
                    if (!isMatched) {
                      input.nextElementSibling.classList.remove("low-stock");
                      input.nextElementSibling.classList.add("disabled");
                    }
                  });
                }
                var getAllCustomUlLI = option.querySelectorAll(".customDropdown ul li");
                if (getAllCustomUlLI) {
                  getAllCustomUlLI.forEach(function (input, key) {
                    var getInputValue = input.querySelector("a span.value span").innerText;
                    var isMatched = false;
                    var addBothValue = option1Value + " / " + getInputValue + " / " + option3Value;
                    document.querySelectorAll(".customProductSelect option").forEach(function (selectOption, selectOptionKey) {
                      var getSelectOptionMatchValue = selectOption.getAttribute("data-match");
                      var variantAvailable = selectOption.getAttribute('data-available');
                      var variantInventory = selectOption.getAttribute("data-inventory");
                      var variantInventoryManagement = selectOption.getAttribute("data-inventory-management");
                      variantInventory = parseInt(variantInventory) + 0;
                      if (typeof getSelectOptionMatchValue != "undefined" && getSelectOptionMatchValue != null && getSelectOptionMatchValue != "") {
                        if (getSelectOptionMatchValue == addBothValue) {
                          isMatched = true;
                          if (variantAvailable == "true") {
                            input.classList.remove("low-stock");
                            input.classList.remove("disabled");
                            if (typeof variantInventoryManagement != "undefined" && variantInventoryManagement != null && variantInventoryManagement != "") {
                              if (variantInventory < 4) {
                                input.classList.remove("disabled");
                                input.classList.add("low-stock");
                              }
                            }
                          } else {
                            input.classList.remove("low-stock");
                            input.classList.add("disabled");
                          }
                        }
                      }
                    });
                    if (!isMatched) {
                      input.classList.remove("low-stock");
                      input.classList.add("disabled");
                    }
                  });
                }
              }
            });
          }
        }
      }
    }
  }, {
    key: "updateOptions",
    value: function updateOptions() {
      var fieldsets = Array.from(this.querySelectorAll('fieldset'));
      this.options = fieldsets.map(function (fieldset) {
        return Array.from(fieldset.querySelectorAll('input')).find(function (radio) {
          return radio.checked;
        }).value;
      });
      this.updateLegends();
    }
  }, {
    key: "updateLegends",
    value: function updateLegends() {
      var fieldsets = Array.from(this.querySelectorAll('fieldset'));
      fieldsets.forEach(function (fieldset) {
        var legend = fieldset.querySelector('legend [data-variant-legend]');
        var selectedOption = Array.from(fieldset.querySelectorAll('input')).find(function (radio) {
          return radio.checked;
        });
        legend.textContent = selectedOption.getAttribute('value');
      });
    }
  }]);
  return VariantRadios;
}(VariantSelects);
customElements.define('variant-radios', VariantRadios);

// Store product handles to history for "recently-viewed" section.
(function () {
  var history = sessionStorage.getItem('Woolman_Product_History') ? sessionStorage.getItem('Woolman_Product_History').split(',') : [];
  var productHandle = window.location.pathname.split('/').pop();
  if (!productHandle) return;
  if (!history.includes(productHandle)) {
    if (history.length >= 10) {
      // only store up to 10 recently viewed products
      history.shift();
    }
    history.push(productHandle);
    sessionStorage.setItem('Woolman_Product_History', history.join(','));
  }
})();
var ProductBuyBar = /*#__PURE__*/function (_HTMLElement2) {
  _inherits(ProductBuyBar, _HTMLElement2);
  var _super3 = _createSuper(ProductBuyBar);
  function ProductBuyBar() {
    "use strict";

    var _this6;
    _classCallCheck(this, ProductBuyBar);
    _this6 = _super3.call(this);
    var classes = {
      show: "show"
    };
    var mainProductForm = document.querySelector(".product-form");
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          // In view -> Hide bar
          _this6.classList.remove(classes.show);
        } else if (window.scrollY > 200) {
          // Out of view AND scrolled a little from top -> Show bar
          _this6.classList.add(classes.show);
        }
      });
    }, {
      threshold: 0.25
    });
    observer.observe(mainProductForm);

    // This script is loaded in product-template.liquid --> Footer observer after DOM ready
    document.addEventListener("DOMContentLoaded", function () {
      var siteFooter = document.querySelector("footer.footer");
      if (!siteFooter) return;
      observer.observe(siteFooter);
    });
    return _this6;
  }
  return _createClass(ProductBuyBar);
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define("product-buy-bar", ProductBuyBar);
var UpsellCard = /*#__PURE__*/function (_HTMLElement3) {
  _inherits(UpsellCard, _HTMLElement3);
  var _super4 = _createSuper(UpsellCard);
  function UpsellCard() {
    var _this7;
    _classCallCheck(this, UpsellCard);
    _this7 = _super4.call(this);
    _this7.select = _this7.querySelector('select');
    _this7.image = _this7.querySelector('.card-media img');
    if (_this7.select) {
      _this7.select.addEventListener('change', function (event) {
        var selectedOption = event.target.options[event.target.selectedIndex];
        var newImgSrc = selectedOption.getAttribute('data-variant-img-src');
        _this7.updateImage(newImgSrc);
      });
    }
    return _this7;
  }
  _createClass(UpsellCard, [{
    key: "updateImage",
    value: function updateImage(newImgSrc) {
      if (this.image) {
        this.image.src = newImgSrc;
      }
    }
  }]);
  return UpsellCard;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
customElements.define('upsell-card', UpsellCard);
var Photoswipe = {
  attempts: 0,
  selectors: {
    images: '.photoswipe__image'
  },
  init: function init() {
    var _this8 = this;
    document.querySelectorAll('.photoswipe__image').forEach(function (trigger) {
      trigger.addEventListener('click', _this8.downloadAndMount.bind(_this8));
    });
  },
  downloadAndMount: function downloadAndMount(evt) {
    var _this9 = this;
    if (this.attempts >= 10) {
      return;
    }
    ;
    this.attempts++;
    var existingScript = document.querySelector("script[src=\"".concat(theme.assets.photoswipe, "\"]"));

    // If we are already processing one slider, wait a while and try again.
    if (window.processingPhotoswipe) {
      setTimeout(this.downloadAndMount.bind(this), 200);
      return;
    }

    // Photoswipe script was already found in document, proceed to immediately mount slider
    if (existingScript) {
      this.showZoom(evt);
      return;
    }

    // Photoswipe script was not found in document, download it and wait for it to load, then show zoom
    window.processingPhotoswipe = true;
    var script = document.createElement('script');
    script.setAttribute('defer', 'true');
    script.setAttribute('async', 'true');
    script.src = theme.assets.photoswipe;
    document.body.append(script);
    script.addEventListener('load', function () {
      _this9.showZoom(evt);
    });
  },
  showZoom: function showZoom(evt) {
    var target = evt.target;
    this.targetElement = target.closest('[data-photoswipe-parent]');
    this.items = this.getImageData();
    this.initGallery(this.items, target.dataset.index || 1);
    window.processingPhotoswipe = false;
  },
  getImageData: function getImageData() {
    this.images = this.targetElement.querySelectorAll(this.selectors.images);
    var items = [];
    this.images.forEach(function (el) {
      var item = {
        src: el.getAttribute('data-photoswipe-src'),
        w: parseInt(el.getAttribute('data-photoswipe-width')),
        h: parseInt(el.getAttribute('data-photoswipe-height')),
        initialZoomLevel: 0.5
      };
      items.push(item);
    });
    return items;
  },
  initGallery: function initGallery(items, index) {
    var pswpElement = document.querySelectorAll('.pswp')[0];
    var options = {
      allowPanToNext: false,
      captionEl: false,
      closeOnScroll: false,
      counterEl: false,
      history: false,
      index: parseInt(index) - 1,
      pinchToClose: false,
      preloaderEl: false,
      shareEl: false,
      tapToToggleControls: false
    };
    this.gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
    this.gallery.init();
  }
};
Photoswipe.init();
if (document.querySelector(".customDropdown ul li")) {
  document.querySelector("a.custom-option-selected").addEventListener('click', function (event) {
    event.preventDefault();
    if (this.parentElement.classList.contains("active")) {
      this.parentElement.classList.remove("active");
    } else {
      this.parentElement.classList.add("active");
    }
  });
  document.addEventListener('click', function (_ref) {
    var target = _ref.target;
    if (target.classList.contains('click-check')) {} else {
      document.querySelector(".customDropdown").classList.remove('active');
    }
  });
  document.querySelectorAll(".customDropdown ul li").forEach(function (el, key) {
    el.querySelector("a").addEventListener('click', function (event) {
      event.preventDefault();
      var getDropdownText = this.querySelector("span.value span").innerText;
      if (typeof getDropdownText != "undefined" && getDropdownText != null && getDropdownText != "") {
        getDropdownText = getDropdownText.toLowerCase();
        this.parentElement.parentElement.parentElement.parentElement.querySelectorAll("input[type=radio]").forEach(function (inputEl, inputKey) {
          var getinputValue = inputEl.getAttribute("value");
          var matchText = getinputValue.toLowerCase();
          if (matchText == getDropdownText) {
            document.querySelector("a.custom-option-selected span").innerText = "";
            document.querySelector("a.custom-option-selected span").innerText = getinputValue;
            document.querySelector(".customDropdown").classList.remove("active");
            document.querySelectorAll(".customDropdown ul li").forEach(function (newEl, newKey) {
              newEl.classList.remove("active");
            });
            el.classList.add("active");
            inputEl.click();
            return false;
          }
        });
      }
    });
  });
}
if (document.querySelector(".customSiteDropdown ul li")) {
  document.querySelector("a.custom-site-option-selected").addEventListener('click', function (event) {
    event.preventDefault();
    if (this.parentElement.classList.contains("active")) {
      this.parentElement.classList.remove("active");
    } else {
      this.parentElement.classList.add("active");
    }
  });
  document.addEventListener('click', function (_ref2) {
    var target = _ref2.target;
    if (target.classList.contains('custom-click-check')) {} else {
      document.querySelector(".customSiteDropdown").classList.remove('active');
    }
  });
  document.querySelectorAll(".customSiteDropdown ul li").forEach(function (el, key) {
    el.querySelector("a").addEventListener('click', function (event) {
      event.preventDefault();
      var getDropdownValue = this.querySelector("span.value span.inner-value").getAttribute("data-value");
      getDropdownValue = parseInt(getDropdownValue) + 0;
      var getDropdownText = this.querySelector("span.value span.inner-value").innerHTML;
      if (typeof getDropdownText != "undefined" && getDropdownText != null && getDropdownText != "") {
        this.parentElement.parentElement.parentElement.parentElement.querySelectorAll("select option").forEach(function (inputEl, inputKey) {
          var getinputValue = inputEl.getAttribute("value");
          getinputValue = parseInt(getinputValue) + 0;
          if (getinputValue == getDropdownValue) {
            document.querySelector("a.custom-site-option-selected span.custom-inner-click-check").innerHTML = "";
            document.querySelector("a.custom-site-option-selected span.custom-inner-click-check").innerHTML = getDropdownText;
            document.querySelector(".customSiteDropdown").classList.remove("active");
            inputEl.parentElement.parentElement.querySelector("select").value = getDropdownValue;
            document.querySelectorAll(".customSiteDropdown ul li").forEach(function (newEl, newKey) {
              newEl.classList.remove("active");
            });
            el.classList.add("active");
            return false;
          }
        });
      }
    });
  });
}
if (document.querySelector(".customLanguageDropdown ul li")) {
  document.querySelector("a.custom-language-option-selected").addEventListener('click', function (event) {
    event.preventDefault();
    if (this.parentElement.classList.contains("active")) {
      this.parentElement.classList.remove("active");
    } else {
      this.parentElement.classList.add("active");
    }
  });
  document.addEventListener('click', function (_ref3) {
    var target = _ref3.target;
    if (target.classList.contains('custom-language-check')) {} else {
      document.querySelector(".customLanguageDropdown").classList.remove('active');
    }
  });
  document.querySelectorAll(".customLanguageDropdown ul li").forEach(function (el, key) {
    el.querySelector("a").addEventListener('click', function (event) {
      event.preventDefault();
      var getDropdownValue = this.querySelector("span.value span").getAttribute("data-value");
      var getDropdownText = this.querySelector("span.value span").innerText;
      if (typeof getDropdownText != "undefined" && getDropdownText != null && getDropdownText != "") {
        this.parentElement.parentElement.parentElement.parentElement.querySelectorAll("select option").forEach(function (inputEl, inputKey) {
          var getinputValue = inputEl.getAttribute("value");
          if (getinputValue == getDropdownValue) {
            document.querySelector("a.custom-language-option-selected span").innerText = "";
            document.querySelector("a.custom-language-option-selected span").innerText = getDropdownText;
            document.querySelector(".customLanguageDropdown").classList.remove("active");
            inputEl.parentElement.parentElement.querySelector("select").value = getDropdownValue;
            document.querySelectorAll(".customLanguageDropdown ul li").forEach(function (newEl, newKey) {
              newEl.classList.remove("active");
            });
            el.classList.add("active");
            return false;
          }
        });
      }
    });
  });
}
if (document.querySelector(".product-image-load-more a")) {
  document.querySelector(".product-image-load-more a").addEventListener('click', function (event) {
    event.preventDefault();
    document.querySelectorAll(".product-media-slider .gridy-track .product-media").forEach(function (option, optionKey) {
      option.classList.remove("hide-media-for-desktop");
    });
    this.parentElement.style.display = "none";
  });
}
if (document.querySelector(".description-non-translated-description")) {
  var handleErrors = function handleErrors(response) {
    if (!response.ok) throw new Error(response.status);
    return response;
  };
  var getCurrentLanguage = document.body.getAttribute("data-current-language");
  if (getCurrentLanguage == "fi" || getCurrentLanguage == "nl") {
    var productHandle = document.querySelector(".description-non-translated-description").getAttribute("data-product-handle");
    if (typeof productHandle != "undefined" && productHandle != null && productHandle != "") {
      var jsonURL = "https://ivalo.com/products/" + productHandle + ".json";
      fetch(jsonURL).then(function (response) {
        response.json().then(function (parsedValue) {
          if (parsedValue.product.body_html != "undefined" && parsedValue.product.body_html != null && parsedValue.product.body_html != "") {
            document.querySelector(".description-non-translated-description").innerHTML = "";
            document.querySelector(".description-non-translated-description").innerHTML = parsedValue.product.body_html;
          }
        });
      });
    }
  }
}
if (document.querySelectorAll(".product-size-guide")) {
  var getAllSizeGuide = document.querySelectorAll(".product-size-guide");
  if(getAllSizeGuide)
  {
    getAllSizeGuide.forEach(function (option, optionKey) {
      if(option.querySelector("a"))
      {
        option.querySelector("a").addEventListener('click', function (event) {
          event.preventDefault();
          var modalId = this.getAttribute("data-modal-id");
          Woolman.ModalsAndDrawers.showModalOrDrawer(modalId);
        });  
      }
    });  
  }
}
if (document.querySelector(".custom-stamped-main-widget")) {
  if (typeof waitForEl !== 'undefined') {
     
  } else {
    var waitForEl = function waitForEl(selector, callback) {
      if (document.querySelector(selector)) {
        callback();
      } else {
        setTimeout(function () {
          waitForEl(selector, callback);
        }, 100);
      }
    };
  }
  waitForEl(".custom-stamped-main-widget .stamped-container", function () {
    var getReviewsCount = document.querySelector(".custom-stamped-main-widget .stamped-container").getAttribute("data-count");
    var reviewsTabContent = document.querySelector(".custom-stamped-main-widget");
    if (typeof getReviewsCount != "undefined" && getReviewsCount != "" && getReviewsCount != null) 
    {
      getReviewsCount = parseInt(getReviewsCount);
      if (getReviewsCount > 0) 
      {
        reviewsTabContent.parentElement.parentElement.parentElement.parentElement.style.display = "block";
        document.querySelector(".product-reviews-wrapper .stamped-main-badge").addEventListener("click", function () {
          if (document.querySelector(".product-block__product_reviews_widget details").hasAttribute("open")) {} else {
            document.querySelector(".product-block__product_reviews_widget details summary").click();
          }
        });
      } 
      else 
      {
        reviewsTabContent.parentElement.parentElement.parentElement.parentElement.style.display = "none";
      }
    }
  });
}